import {AsyncStorage} from './models';
import {Injectable} from '@angular/core';

@Injectable()
export class AsyncSessionStorage implements AsyncStorage {
  /**
   * Get the value with the given key.
   */
  get(options: {key: string}): Promise<{
    value: string | null;
  }> {
    return Promise.resolve().then(() => ({value: sessionStorage.getItem(options.key)}));
  }

  /**
   * Set the value for the given key
   */
  set(options: {key: string; value: string}): Promise<void> {
    return Promise.resolve().then(() => sessionStorage.setItem(options.key, options.value));
  }

  /**
   * Remove the value for this key (if any)
   */
  remove(options: {key: string}): Promise<void> {
    return Promise.resolve().then(() => sessionStorage.removeItem(options.key));
  }

  /**
   * Clear stored keys and values.
   */
  clear(): Promise<void> {
    return Promise.resolve().then(() => sessionStorage.clear());
  }

  /**
   * Return the list of known keys
   */
  keys(): Promise<{
    keys: string[];
  }> {
    return Promise.resolve().then(() => ({keys: [...Array(sessionStorage.length).keys()].map(i => sessionStorage.key(i))}));
  }
}
